<template>
  <Modal v-model="show" width="50%" @on-visible-change="closeHandle" @on-ok="confirm">
    <Form ref="formInline" inline class="my-5" label-position="top">
      <FormItem>
        <Input type="text" v-model="query.nameLk" placeholder="请输入名称">
        </Input>
      </FormItem>
      <FormItem>
        <Input type="text" v-model="query.cityLk" placeholder="请输入城市">
        </Input>
      </FormItem>
      <FormItem>
        <Input
          type="text"
          v-model="query.addressLk"
          placeholder="请输入地址"
        >
        </Input>
      </FormItem>
      <FormItem>
        <Button type="primary" @click="search">查询</Button>
      </FormItem>
    </Form>
    <Table ref="selection" :columns="columns" :data="tableData"></Table>
    <div class="flex align-center">
      <div class="flex-auto">
        <Page
          class-name="my-5"
          :total="total"
          :page-size="query.pageSize"
          @on-change="pageChange"
        />
      </div>
    </div>
  </Modal>
</template>

<script>
import service, { Village } from '@/api/village/Village'
import { queryHandle } from '@/ts/tool'

export default {
  name: 'VillageSelector',
  props: ['callback'],
  data () {
    return {
      currentChoose: '',
      show: false,
      tableData: [],
      columns: [
        {
          width: 60,
          align: 'center',
          title: '',
          render: (h, params) => {
            let id = params.row.id
            let flag = this.currentChoose === id
            let self = this
            return h('div', [
              h('Radio', {
                props: {
                  value: flag
                },
                on: {
                  'on-change': () => {
                    self.currentChoose = id
                  }
                }
              })
            ])
          }
        },
        {
          title: '名称',
          key: 'name'
        },
        {
          title: '城市',
          key: 'city'
        },
        {
          title: '地址',
          key: 'address'
        },
        {
          title: '创建时间',
          key: 'createTime'
        }
      ],
      total: 0,
      query: {
        page: 1,
        pageSize: 10,
        nameLk: '',
        cityLk: '',
        addressLk: ''
      }
    }
  },
  created () {
    this.search()
  },
  methods: {
    search () {
      queryHandle(this.query)
      service.getPagesOfVillage(this.query).then((res) => {
        if (res.result) this.tableData = res.result.items
        this.total = res.result['total']
        this.show = true
      })
    },
    pageChange (e) {
      this.query.page = e
      this.search()
    },
    confirm () {
      this['callback'](this.tableData.find(v => v.id === this.currentChoose))
    },
    closeHandle (res) {
      if (!res) {
        setTimeout(() => {
          this.$el.remove()
        }, 500)
      }
    }
  }
}
</script>

<style scoped lang="scss"></style>
